module.exports = __webpack_public_path__ + "img/sector1_doubles.a241db28.svg";